<template>
  <div class="list" v-if="list.length > 0">
    <div class="toptitle">
      <p>服务项目</p>
    </div>
    <div class="con">
      <div class="listbox">
        <router-link
          :to="{
            path: $Router.servicescontent.path,
            query: {
              id: item.id,
            },
          }"
          class="item"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="text">
            <div class="title">{{ item.title }}</div>
            <div class="info">
              {{ item.description }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import service from './list'

export default {
  name: 'list',
  data () {
    return {
      limit: 10,
      total: 0,
      page: 1,
      list: []
    }
  },
  computed: {
    cate_id () {
      return this.$route.query.cateid
    }
  },
  watch: {
    cate_id () {
      service.getArtivleList(this)
    }
  },
  methods: {
    currentChange (index) {
      this.page = index
      service.getArtivleList(this)
    }
  },
  created () {
    service.getArtivleList(this)
  }
}
</script>

<style lang="scss" scoped>
@import "./list.scss";
</style>



// WEBPACK FOOTER //
// src/components/services/list/list.vue